import { createAction, props } from '@ngrx/store';
import { ICustomKegMon } from 'app/models/customKegMon';

export const clearAllItems = createAction('[DalHelper] Clear All CustomKegMon');
export const loadItems = createAction('[App Custom Keg Mon List Page] Load CustomKegMon', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsSuccess = createAction('[Custom Keg Mon API] Load CustomKegMon Success', props<{ items: ICustomKegMon[] }>());
export const loadItemsFailure = createAction('[Custom Keg Mon API] Load CustomKegMon Failure', props<{ error: any }>());
